import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import Snippet from "../snippet.mdx";
import DetailGroupProductsInOneProject from "./details/group-products-in-one-project.mdx";
import DetailSetUpReverseProxy from "./details/set-up-reverse-proxy.mdx";
import DetailPostHogIPs from "./details/posthog-ips.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`This is the simplest way to get PostHog up and running. It only takes a few minutes.`}</p>
    <p>{`Copy the snippet below and replace `}<inlineCode parentName="p">{`<ph_project_api_key>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<ph_client_api_host>`}</inlineCode>{` with your project's values, then add it within the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tags at the base of your product - ideally just before the closing `}<inlineCode parentName="p">{`</head>`}</inlineCode>{` tag. This ensures PostHog loads on any page users visit.`}</p>
    <p>{`You can find the snippet pre-filled with this data in `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings/project#snippet"
      }}>{`your project settings`}</a>{`.`}</p>
    <Snippet mdxType="Snippet" />
    <p>{`Once the snippet is added, PostHog automatically captures `}<inlineCode parentName="p">{`$pageview`}</inlineCode>{` and `}<a parentName="p" {...{
        "href": "/docs/data/autocapture"
      }}>{`other events`}</a>{` like button clicks. You can then enable other products, such as session replays, within `}<a parentName="p" {...{
        "href": "https://us.posthog.com/settings"
      }}>{`your project settings`}</a>{`. `}</p>
    <br />
    <DetailSetUpReverseProxy mdxType="DetailSetUpReverseProxy" />
    <DetailGroupProductsInOneProject mdxType="DetailGroupProductsInOneProject" />
    <DetailPostHogIPs mdxType="DetailPostHogIPs" />
    <details>
  <summary>Include ES5 support (optional)</summary>
      <p>{`  If you need ES5 support for example to track Internet Explorer 11 replace `}<inlineCode parentName="p">{`/static/array.js`}</inlineCode>{` in the snippet with `}<inlineCode parentName="p">{`/static/array.full.es5.js`}</inlineCode></p>
    </details>
    <details>
  <summary>Working with AI code editors?</summary>
      <p>{`  If you’re working with AI code editors (like Lovable, Bolt.new, Replit, and others), it’s easy to install PostHog. Just give it this prompt: `}<inlineCode parentName="p">{`npx -y @posthog/wizard@latest`}</inlineCode></p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      